/**
 * Dimension names that hold a raw device ID.
 * Used both by the server-side enrichment (to replace IDs with names in query results)
 * and by the client-side legend renderer (to choose the deviceNameRenderer for these columns).
 */
export const DEVICE_ID_DIMENSIONS: readonly string[] = ['i_device_id', 'device_id'];

/**
 * The dimension name that holds the human-readable device name after enrichment.
 */
export const DEVICE_NAME_DIMENSION = 'i_device_name' as const;

/**
 * Dimension names that hold a raw SNMP interface ID (snmp_id).
 * Used by the query augmenter to ensure i_device_id is always fetched alongside
 * interface dimensions, and by the server-side enrichment to resolve interface descriptions.
 * Keep in sync with interfaceMetrics in app/components/dataviews/views/legend/legendUtils.js.
 */
export const INTERFACE_ID_DIMENSIONS: readonly string[] = [
  'input_port',
  'output_port',
  'bgp_ult_exit_interface',
  'InterfaceID_src',
  'InterfaceID_dst',
  'ktsubtype__advanced_sflow__INT00',
  'ktsubtype__advanced_sflow__INT01',
  'ktappprotocol__snmp__output_port',
  'ktappprotocol__st__output_port'
];
